import { QuantityInput } from "@/shared/presentation/components/QuantityInput";
import { TotalPrice } from "@/shared/presentation/components/TotalPrice";
import { useQuantityBarComponent } from "@/configurator/presentation/useQuantityBarComponent";

export function QuantityBar() {
  const { quantity, total, setQuantity } = useQuantityBarComponent();

  return (
    <div className="quantity-bar">
      <QuantityInput value={quantity} onChange={setQuantity} />
      <TotalPrice amount={total.amount} currency={total.currency} />
    </div>
  );
}
